/**
 * AS | Announcement Bar — as-ck
 * Drives the prev/next buttons and autoplay for the scroll-snap item strip
 * (mobile/tablet only — the strip is non-scrollable once CSS switches to a
 * row at 1024px, so autoplay is a no-op there).
 * Both manual clicks and autoplay loop through scrollByStep() — at either
 * end it wraps around instead of stopping, so the nav buttons are never
 * disabled and clicking "next" on the last slide always works.
 */
(function () {
  'use strict';

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function isCarouselActive(list) {
    return list.scrollWidth > list.clientWidth + 1;
  }

  function scrollByStep(list, direction) {
    const firstItem = list.querySelector('.as-ck-ab__item');
    const step = firstItem ? firstItem.getBoundingClientRect().width + 24 : list.clientWidth * 0.8;
    const maxScroll = list.scrollWidth - list.clientWidth;
    const behavior = reduceMotion ? 'auto' : 'smooth';

    if (direction > 0 && list.scrollLeft >= maxScroll - 1) {
      list.scrollTo({ left: 0, behavior });
      return;
    }
    if (direction < 0 && list.scrollLeft <= 1) {
      list.scrollTo({ left: maxScroll, behavior });
      return;
    }
    list.scrollBy({ left: step * direction, behavior });
  }

  function initBar(root) {
    const list = root.querySelector('.as-ck-ab__list');
    const prevBtn = root.querySelector('.as-ck-ab__nav--prev');
    const nextBtn = root.querySelector('.as-ck-ab__nav--next');
    if (!list || !prevBtn || !nextBtn) return;

    prevBtn.addEventListener('click', () => scrollByStep(list, -1));
    nextBtn.addEventListener('click', () => scrollByStep(list, 1));

    // ─── Autoplay ─────────────────────────────────────────────────────────
    const autoplayEnabled = root.dataset.autoplay === 'true' && !reduceMotion;
    const autoplaySpeed = (parseFloat(root.dataset.autoplaySpeed, 10) || 5) * 1000;
    let autoplayTimer = null;

    function advance() {
      scrollByStep(list, 1);
    }

    function stopAutoplay() {
      if (autoplayTimer) {
        clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }

    function startAutoplay() {
      stopAutoplay();
      if (!autoplayEnabled || !isCarouselActive(list) || document.hidden) return;
      autoplayTimer = setInterval(advance, autoplaySpeed);
    }

    function restartAutoplay() {
      if (!autoplayEnabled) return;
      startAutoplay();
    }

    if (autoplayEnabled) {
      ['pointerdown', 'focusin'].forEach((evt) => {
        root.addEventListener(evt, stopAutoplay);
      });
      ['pointerup', 'focusout'].forEach((evt) => {
        root.addEventListener(evt, restartAutoplay);
      });
      document.addEventListener('visibilitychange', restartAutoplay);
      window.addEventListener('resize', restartAutoplay);

      startAutoplay();
    }
  }

  document.querySelectorAll('.as-ck-ab').forEach(initBar);
})();
